module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHRpdGxlPnRleHQtaXRhbGljPC90aXRsZT48cGF0aCBkPSJNMjIuNS4yNDhIMTQuODYzYTEuMjUsMS4yNSwwLDAsMCwwLDIuNWgxLjA4NmEuMjUuMjUsMCwwLDEsLjIxMS4zODRMNC43OCwyMS4wMTdhLjUuNSwwLDAsMS0uNDIyLjIzMUgxLjVhMS4yNSwxLjI1LDAsMCwwLDAsMi41SDkuMTM3YTEuMjUsMS4yNSwwLDAsMCwwLTIuNUg4LjA1MWEuMjUuMjUsMCwwLDEtLjIxMS0uMzg0TDE5LjIyLDIuOThhLjUuNSwwLDAsMSwuNDIyLS4yMzJIMjIuNWExLjI1LDEuMjUsMCwwLDAsMC0yLjVaIi8+PC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/italic.svg
// module id = ojIv
// module chunks = 1